import { render, staticRenderFns } from "./WorkList.vue?vue&type=template&id=1320d6de&scoped=true"
import script from "./WorkList.vue?vue&type=script&lang=js"
export * from "./WorkList.vue?vue&type=script&lang=js"
import style0 from "./WorkList.vue?vue&type=style&index=0&id=1320d6de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320d6de",
  null
  
)

export default component.exports